import { render, staticRenderFns } from "./MilkglassLayer.vue?vue&type=template&id=2924bae2&"
import script from "./MilkglassLayer.vue?vue&type=script&lang=js&"
export * from "./MilkglassLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports